export default __webpack_public_path__ + "static/media/delete.da6890b2.png";